export type GraphBounds = {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
};
